import { render, staticRenderFns } from "./referee.vue?vue&type=template&id=09fd95ce&scoped=true"
import script from "./referee.vue?vue&type=script&lang=js"
export * from "./referee.vue?vue&type=script&lang=js"
import style0 from "./referee.vue?vue&type=style&index=0&id=09fd95ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd95ce",
  null
  
)

export default component.exports